import React from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import PageSEO from '../../components/SEO/PageSEO';

const Confidentialite = () => {
    // Schéma JSON-LD pour la page mentions légales
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Politique de Confidentialité - Comprendre les SES",
    "description": "Politique de confidentialité du site Comprendre les SES, informations sur la collecte et l'utilisation des données personnelles, les cookies, la protection des données, la durée de conservation, vos droits et le partage des données.",
    "publisher": {
      "@type": "Organization",
      "name": "Comprendre les SES",
      "logo": "https://cours-ses.fr/Logo SES.png"
    },
    "license": "https://cours-ses.fr/confidentialite"
  };
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <main className="pt-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="bg-white rounded-lg shadow-lg p-8">
            <h1 className="text-3xl font-bold text-[#323c5f] mb-8">Politique de Confidentialité</h1>
            
            <div className="space-y-8 text-gray-600">
              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">1. Collecte des données personnelles</h2>
                <p className="mb-4">
                  Chez "Comprendre les SES", nous accordons une importance particulière à la protection de vos données personnelles. Cette politique de confidentialité vous informe sur la manière dont nous collectons, utilisons et protégeons vos informations lorsque vous utilisez notre site web et nos services.
                </p>
                <p className="mb-4">
                  Nous collectons les types de données suivants :
                </p>
                <ul className="list-disc pl-6 mb-4">
                  <li><strong>Données d'identification :</strong> nom, prénom, adresse email, numéro de téléphone</li>
                  <li><strong>Données de facturation :</strong> adresse postale, informations de paiement</li>
                  <li><strong>Données de connexion :</strong> adresse IP, type de navigateur, pages visitées, durée de la visite</li>
                  <li><strong>Préférences :</strong> préférences de communication</li>
                </ul>
                <p>
                  Ces données sont collectées lorsque vous :
                </p>
                <ul className="list-disc pl-6">
                  <li>Créez un compte sur notre site</li>
                  <li>Effectuez un achat</li>
                  <li>Réservez un cours particulier</li>
                  <li>Téléchargez des ressources gratuites</li>
                  <li>Naviguez sur notre site (via les cookies)</li>
                  <li>Nous contactez via notre formulaire de contact</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">2. Utilisation des données</h2>
                <p className="mb-4">
                  Nous utilisons vos données personnelles pour les finalités suivantes :
                </p>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#323c5f] mb-2">Exécution du contrat</h3>
                    <ul className="list-disc pl-6 text-sm">
                      <li>Gérer votre compte utilisateur</li>
                      <li>Traiter vos commandes et paiements</li>
                      <li>Organiser les cours particuliers</li>
                      <li>Vous donner accès aux ressources achetées</li>
                      <li>Assurer le service après-vente</li>
                    </ul>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#323c5f] mb-2">Intérêt légitime</h3>
                    <ul className="list-disc pl-6 text-sm">
                      <li>Améliorer nos produits et services</li>
                      <li>Analyser l'utilisation de notre site</li>
                      <li>Prévenir la fraude</li>
                      <li>Assurer la sécurité de notre site</li>
                      <li>Personnaliser votre expérience</li>
                    </ul>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#323c5f] mb-2">Consentement</h3>
                    <ul className="list-disc pl-6 text-sm">
                      <li>Vous envoyer notre newsletter</li>
                      <li>Vous proposer des offres personnalisées</li>
                      <li>Utiliser certains cookies non essentiels</li>
                      <li>Partager des témoignages (avec votre accord)</li>
                    </ul>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#323c5f] mb-2">Obligation légale</h3>
                    <ul className="list-disc pl-6 text-sm">
                      <li>Respecter nos obligations comptables et fiscales</li>
                      <li>Répondre aux demandes des autorités compétentes</li>
                      <li>Conserver les preuves d'achat et de paiement</li>
                    </ul>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">3. Cookies</h2>
                <p>
                  Notre site utilise des cookies pour améliorer votre expérience de navigation. Les cookies sont de petits fichiers texte stockés sur votre appareil qui nous aident à :
                </p>
                <ul className="list-disc pl-6 mt-2">
                  <li>Mémoriser vos préférences et paramètres</li>
                  <li>Comprendre comment vous utilisez notre site</li>
                  <li>Améliorer notre site en fonction de vos besoins</li>
                  <li>Vous proposer des contenus et services personnalisés</li>
                </ul>
                
                <h3 className="text-lg font-semibold text-[#323c5f] mt-4 mb-2">Types de cookies utilisés</h3>
                
                <div className="space-y-3 mt-3">
                  <div>
                    <h4 className="font-semibold text-[#323c5f]">Cookies nécessaires</h4>
                    <p className="text-sm">
                      Ces cookies sont indispensables au fonctionnement du site et ne peuvent pas être désactivés.
                      Ils ne stockent aucune information personnelle identifiable.
                    </p>
                  </div>
                  
                  <div>
                    <h4 className="font-semibold text-[#323c5f]">Cookies analytiques</h4>
                    <p className="text-sm">
                      Ces cookies nous permettent d'analyser l'utilisation du site afin d'en améliorer les performances et l'expérience utilisateur.
                      Toutes les informations collectées sont anonymes.
                    </p>
                  </div>
                  
                  <div>
                    <h4 className="font-semibold text-[#323c5f]">Cookies marketing</h4>
                    <p className="text-sm">
                      Ces cookies sont utilisés pour suivre les visiteurs sur les sites web. L'objectif est d'afficher des publicités pertinentes
                      et engageantes pour l'utilisateur.
                    </p>
                  </div>
                </div>
                
                <h3 className="text-lg font-semibold text-[#323c5f] mt-4 mb-2">Gestion des cookies</h3>
                <p>
                  Vous pouvez à tout moment modifier vos préférences en matière de cookies en cliquant sur le lien "Gérer les cookies" en bas de page.
                  Vous pouvez également configurer votre navigateur pour refuser tous les cookies ou pour qu'il vous avertisse lorsqu'un cookie est envoyé.
                  Veuillez noter que certaines fonctionnalités du site pourraient ne plus être disponibles si vous désactivez les cookies.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">4. Protection des données</h2>
                <p>
                  Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos données 
                  personnelles contre tout accès, modification, divulgation ou destruction non autorisée.
                </p>
                <div className="bg-gray-50 p-4 rounded-lg mt-4">
                  <h3 className="font-semibold text-[#323c5f] mb-2">Mesures de sécurité mises en place :</h3>
                  <ul className="list-disc pl-6">
                    <li>Chiffrement des données sensibles (SSL/TLS)</li>
                    <li>Accès limité aux données personnelles</li>
                    <li>Authentification à deux facteurs pour les administrateurs</li>
                    <li>Mises à jour régulières de nos systèmes de sécurité</li>
                    <li>Sauvegardes régulières des données</li>
                    <li>Formation de notre personnel aux bonnes pratiques de sécurité</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">5. Durée de conservation</h2>
                <p>
                  Nous conservons vos données personnelles aussi longtemps que nécessaire pour les 
                  finalités pour lesquelles elles ont été collectées, dans le respect des obligations 
                  légales applicables.
                </p>
                <div className="overflow-x-auto mt-4">
                  <table className="min-w-full bg-white border border-gray-200 rounded-lg">
                    <thead>
                      <tr className="bg-gray-50">
                        <th className="py-2 px-4 border-b text-left">Type de données</th>
                        <th className="py-2 px-4 border-b text-left">Durée de conservation</th>
                        <th className="py-2 px-4 border-b text-left">Justification</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="py-2 px-4 border-b">Données de compte</td>
                        <td className="py-2 px-4 border-b">Jusqu'à la suppression du compte</td>
                        <td className="py-2 px-4 border-b">Nécessaire pour fournir nos services</td>
                      </tr>
                      <tr>
                        <td className="py-2 px-4 border-b">Données de commande</td>
                        <td className="py-2 px-4 border-b">10 ans</td>
                        <td className="py-2 px-4 border-b">Obligations légales (comptabilité)</td>
                      </tr>
                      <tr>
                        <td className="py-2 px-4 border-b">Données de paiement</td>
                        <td className="py-2 px-4 border-b">13 mois après la transaction</td>
                        <td className="py-2 px-4 border-b">Preuve de paiement et gestion des réclamations</td>
                      </tr>
                      <tr>
                        <td className="py-2 px-4 border-b">Données de navigation</td>
                        <td className="py-2 px-4 border-b">13 mois</td>
                        <td className="py-2 px-4 border-b">Analyse et amélioration du site</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">6. Vos droits</h2>
                <p>
                  Conformément au RGPD, vous disposez des droits suivants :
                </p>
                <ul className="list-disc pl-6">
                  <li>Droit d'accès à vos données</li>
                  <li>Droit de rectification</li>
                  <li>Droit à l'effacement</li>
                  <li>Droit à la limitation du traitement</li>
                  <li>Droit à la portabilité des données</li>
                  <li>Droit d'opposition</li>
                </ul>
                <p className="mt-3">
                  Pour exercer ces droits, veuillez nous contacter à l'adresse email suivante : comprendrelessespro@gmail.com
                </p>
                <div className="bg-yellow-50 p-4 rounded-lg mt-4 border border-yellow-100">
                  <p className="text-yellow-800">
                    <strong>Délai de réponse :</strong> Nous nous engageons à répondre à toute demande relative à vos droits dans un délai d'un mois à compter de la réception de votre demande. Ce délai peut être prolongé de deux mois supplémentaires si nécessaire, compte tenu de la complexité et du nombre de demandes.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">7. Partage des données</h2>
                <p className="mb-4">
                  Nous pouvons partager vos données personnelles avec les tiers suivants :
                </p>
                <ul className="list-disc pl-6 mb-4">
                  <li><strong>Prestataires de services :</strong> pour nous aider à fournir nos services (hébergement, paiement, envoi d'emails)</li>
                  <li><strong>Partenaires commerciaux :</strong> uniquement avec votre consentement explicite</li>
                  <li><strong>Autorités compétentes :</strong> lorsque la loi nous y oblige</li>
                </ul>
                <p>
                  Nous nous assurons que tous nos prestataires respectent les mêmes standards de protection des données que nous et qu'ils n'utilisent vos données que pour les finalités spécifiées.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">8. Modifications</h2>
                <p>
                  Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment.
                  Toute modification sera publiée sur cette page avec une date de mise à jour.
                  Nous vous encourageons à consulter régulièrement cette page pour rester informé des éventuelles modifications.
                </p>
                <p className="mt-2">
                  Dernière mise à jour : 27 février 2025
                </p>
              </section>

              <div className="bg-red-50 p-6 rounded-lg border border-red-100 mt-8">
                <h3 className="text-lg font-semibold text-red-800 mb-2">Sanctions en cas de non-respect du RGPD</h3>
                <p className="text-red-700">
                  Le non-respect des dispositions du RGPD peut entraîner des sanctions administratives pouvant aller jusqu'à 20 millions d'euros ou 4% du chiffre d'affaires annuel mondial, le montant le plus élevé étant retenu. Ces sanctions sont proportionnées à la gravité de l'infraction et peuvent être accompagnées d'autres mesures correctives.
                </p>
              </div>

              <p className="text-sm text-gray-500 text-right mt-8">
                Pour toute question concernant cette politique de confidentialité, veuillez nous contacter à l'adresse : comprendrelessespro@gmail.com
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Confidentialite;